module.exports = __webpack_public_path__ + "static/forecast/weather/dayheavyrain-0385300f3d6ec189160c8333d6c51fc4.svg";